/* QB product cards (T4): a card title with three " - " segments (print - fabric - garment) shows the print name only.
   Text-transform, size and the two-line clamp come from theme settings and qb-global.css. */
(function () {
  if (window.__qbCards) return;
  window.__qbCards = true;
  var SEL = '.product-item__product-title a, .search-item__title a, .recently-viewed-product-item__title a';
  // Ready to ship badge: the ready-to-ship collection is the products tagged "Express"; the theme's custom badge
  // (badge group 2) shows the tag text itself, so the label is swapped here — no product data touched.
  var BADGE = '.product-badge';
  function badges(root) {
    (root.querySelectorAll ? root.querySelectorAll(BADGE) : []).forEach(function (b) {
      if ((b.textContent || '').trim().toLowerCase() === 'express') b.textContent = 'Ready to ship';
    });
  }
  function fix(root) {
    (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(function (a) {
      if (a.dataset.qbTitle) return;
      var t = (a.textContent || '').trim();
      var parts = t.replace(/ [–—] /g, ' - ').split(' - ');
      if (parts.length === 3) { a.textContent = parts[0].trim(); a.setAttribute('title', t); }
      a.dataset.qbTitle = '1';
    });
  }
  fix(document); badges(document);
  new MutationObserver(function (rs) { rs.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) { fix(n); badges(n); } }); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
